import { UnreachableCaseError } from 'ts-essentials';
import { DefaultView } from '../../../utils/userSettings';
import { IEntityNode } from '../../Builder/EntitySelection/types';
import { EntityDropzoneType, EntityTabType } from './types';

export const getEntityHelpLink = (
  entityTabType: EntityTabType,
  defaultView: DefaultView,
) => {
  if (defaultView === DefaultView.ManagedView) {
    return 'https://docs.kubit.ai/docs/dictionary#build-a-managed-view';
  }

  switch (entityTabType) {
    case EntityTabType.Measures:
      return 'https://docs.kubit.ai/docs/components-of-a-report#saving-and-updating-measures';
    case EntityTabType.Cohorts:
      return 'https://docs.kubit.ai/docs/cohorts#creating-a-cohort';
    default:
      return 'https://docs.kubit.ai/docs/getting-started';
  }
};

export const getEntityType = (node: IEntityNode) => {
  switch (node.__typename) {
    case 'TagLeafBasicEvent':
    case 'TagLeafVirtualEvent':
    case 'TagLeafAnyEvent':
    case 'TagLeafAnyTableEvent':
      return EntityDropzoneType.Events;
    case 'TagLeafCompoundCohort':
    case 'TagLeafSimpleCohort':
      return EntityDropzoneType.Cohorts;
    case 'TagLeafCompoundMeasure':
    case 'TagLeafSimpleMeasure':
      return EntityDropzoneType.Measures;
    case 'TagLeafField':
      return EntityDropzoneType.Fields;
    case 'TagLeafFilter':
      return EntityDropzoneType.Filters;
    case 'TagLeafCustomBucketDef':
    case 'TagLeafDateBucketDef':
    case 'TagLeafEnumBucketDef':
    case 'TagLeafRangeBucketDef':
      return null;
    default:
      throw new UnreachableCaseError(node);
  }
};
